export const gameInviteReminderNotification = {
    type: 'game-invite-reminder',
    name: 'Game Invite Reminder',
    description: "Reminds you that you have a pending game invitation that you haven't responded to yet.",
    defaultEnabled: true,
    text(data, context) {
        const invitedAt = new Date(data.invitedAt);
        const now = new Date();
        const daysAgo = Math.floor((now.getTime() - invitedAt.getTime()) / (1000 * 60 * 60 * 24));
        return `You were invited to play ${data.gameTitle ?? 'a game'} ${daysAgo} days ago.${context === 'push' ? ' Tap to join!' : ''}`;
    },
    title(data) {
        return `Reminder: Join ${data.gameTitle ?? 'a game on Rout'}!`;
    },
    link(data) {
        return `/session/${data.gameSessionId}`;
    },
};
//# sourceMappingURL=gameInviteReminder.js.map